import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackCTAClick } from "@/lib/analytics";

export const FinalCTA = () => (
    <section
        data-testid="final-cta-section"
        className="relative overflow-hidden bg-[#0B1F44] py-24 lg:py-32"
    >
        <div
            className="pointer-events-none absolute -left-32 top-0 h-[360px] w-[360px] rounded-full bg-[#2563EB]/20 blur-3xl"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute -bottom-32 -right-16 h-[360px] w-[360px] rounded-full bg-[#60A5FA]/10 blur-3xl"
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-8">
            <Reveal>
                <h2 className="text-3xl font-bold tracking-tight text-white lg:text-4xl">
                    Ready to see where your marketing can work harder?
                </h2>
                <a
                    href="#growth-review"
                    data-testid="final-cta-button"
                    onClick={() => trackCTAClick("final_cta")}
                    className="mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-[#2563EB] px-8 py-4 text-base font-semibold text-white transition-all hover:bg-blue-600 hover:shadow-lg hover:shadow-blue-600/30"
                >
                    Book a 20-minute Growth Review
                    <ArrowRight className="h-4 w-4" />
                </a>
            </Reveal>
        </div>
    </section>
);
